module.exports = __webpack_public_path__ + "static/img/good.e75fd8d3.png";